'use strict';

var scrollAnimate = require('./scrollAnimate');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for email sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status = 'alert-success';

    if ($('.email-signup-message').length === 0) {
        $('body').append(
            '<div class="email-signup-message"></div>'
        );
    }
    $('.email-signup-message')
        .append('<div class="email-signup-alert text-center ' + status + '">' + data + '</div>');

    setTimeout(function () {
        $('.email-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}

function applySlick(parent) {
    var $this = $(parent);
    $($this).slick({
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        infinite: false,
        arrows: true,
        autoplay: false,
        responsive: [{
            breakpoint: 1240,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1,
                dots: false
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: false
            }
        }, {
            breakpoint: 544,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            }
        },
        {
            breakpoint: 300,
            settings: {
                slidesToShow: 8 / 6,
                slidesToScroll: 1,
            }
        }
        ]
    });
}

/**
 * Get cookie value by cookie name from browser
 * @param {string} cookieName - name of the cookie
 * @returns {string} cookie value of the found cookie name
 */
function getCookie(cookieName) {
    var name = cookieName + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var cookieArray = decodedCookie.split(';');
    for (var i = 0; i < cookieArray.length; i++) {
        var cookieItem = cookieArray[i];
        while (cookieItem.charAt(0) === ' ') {
            cookieItem = cookieItem.substring(1);
        }
        if (cookieItem.indexOf(name) === 0) {
            return cookieItem.substring(name.length, cookieItem.length);
        }
    }
    return '';
}

module.exports = function () {
    $('.footer-signup').on('click', function (e) {
        e.preventDefault();
        var theForm = $(this).parents('form');
        var url = $(this).parents('form').attr('action');
        var button = $(this);
        var input = $('#news_Email');
        var mailformat = /^[a-zA-Z0-9.!#$%&amp;'*+\/=?^_`\{\|\}~\-]+@[a-zA-Z0-9]+(?:-[a-zA-Z0-9]{1,15})*(?:\.[a-zA-Z0-9]{2,15}(?:-[a-zA-Z0-9]{2,15})*)+$/;

        var isValid = input[0].checkValidity();

        if (!isValid || !$(input).val().match(mailformat)) {
            $('.signup-box').addClass('is-invalid');
            theForm.find('.invalid-feedback').text('Please provide a valid email address');
            return false;
        } else {
            $('.signup-box').removeClass('is-invalid');
        }

        $.spinner().start();
        $(this).attr('disabled', true);
        $.ajax({
            url: url,
            type: 'post',
            data: $(theForm).serialize(),
            success: function (data) {
                theForm.find('input.signup-box').val('');
                displayMessage(data, button);
            },
            error: function (err) {
                displayMessage(err, button);
            }
        });
    });

    $(window).on('load', function () {

        var sgRcRedirectionBtn = $('.rc-sg-redirection-btn');  // Replace with your parent div selector

        // Check if the URL contains 'style-guide-global' or 'reusable-component'
        if (window.location.href.indexOf('style-guide-global') !== -1) {
            sgRcRedirectionBtn.addClass('sg-page').removeClass('rc-page');
        } else if (window.location.href.indexOf('reusable-component') !== -1) {
            sgRcRedirectionBtn.addClass('rc-page').removeClass('sg-page');
        }

        if ($('.global-style-guide').length > 0) {
            // Define the properties for each style set
            const styleConfig = {
                'sg-style-set1': ['fontFamily', 'fontSize', 'fontWeight', 'lineHeight', 'color', 'textDecoration', 'border'],
                'sg-style-set2': ['fontFamily', 'fontSize', 'textDecoration', 'border'],
                'sg-style-set3': ['padding', 'fontFamily', 'fontSize', 'color', 'textDecoration', 'border', 'outline', 'backgroundColor'],
            };
        
            // Define default values for properties
            const defaultValues = {
                fontWeight: 400,
                textDecoration: 'none',
                border: 'none',
            };
        
            // Function to convert RGB to Hex
            const rgbToHex = (rgb) => {
                const rgbValues = rgb.match(/\d+/g);
                return "#" + ((1 << 24) + (+rgbValues[0] << 16) + (+rgbValues[1] << 8) + +rgbValues[2]).toString(16).slice(1);
            };
        
            // Function to get computed styles
            const getComputedStyles = (element) => {
                const computedStyle = window.getComputedStyle(element);
                return {
                    fontFamily: computedStyle.fontFamily,
                    fontSize: computedStyle.fontSize,
                    fontWeight: computedStyle.fontWeight,
                    lineHeight: computedStyle.lineHeight,
                    color: rgbToHex(computedStyle.color),
                    textDecoration: computedStyle.textDecoration.split(' ')[0],
                    borderTop: computedStyle.borderTop,
                    borderRight: computedStyle.borderRight,
                    borderBottom: computedStyle.borderBottom,
                    borderLeft: computedStyle.borderLeft,
                    backgroundColor: rgbToHex(computedStyle.backgroundColor),
                    outline: computedStyle.outline,
                };
            };
        
            // Function to handle style extraction and display
            const handleStyleExtraction = (targetElement, styleSetClass) => {
                const computedStyle = window.getComputedStyle(targetElement[0]); // Get computed styles
                const styleInfo = {};
                const borderInfo = {};
        
                // Get the specified properties for the current style set
                if (styleConfig[styleSetClass]) {
                    styleConfig[styleSetClass].forEach(prop => {
                        if (prop === 'border') {
                            // Handle border properties separately
                            const borderProps = ['borderTop', 'borderRight', 'borderBottom', 'borderLeft'];
                            borderProps.forEach(borderProp => {
                                borderInfo[borderProp] = computedStyle[borderProp];
                            });
                        } else {
                            styleInfo[prop] = computedStyle[prop];
                        }
                    });
        
                    // Convert colors to hex if needed
                    if (styleInfo.color) {
                        styleInfo.color = rgbToHex(styleInfo.color);
                    }
        
                    if (styleInfo.backgroundColor) {
                        styleInfo.backgroundColor = rgbToHex(styleInfo.backgroundColor);
                    }
        
                    // Calculating Line-Height in %
                    if (styleInfo.lineHeight) {
                        const lineHeightPx = parseFloat(styleInfo.lineHeight);
                        const fontSizePx = parseFloat(computedStyle.fontSize); // Get fontSize from computedStyle
        
                        if (fontSizePx) {
                            const lineHeightPercentage = ((lineHeightPx / fontSizePx) * 100).toFixed(0) + '%';
                            styleInfo.lineHeight = `${lineHeightPx}px <span style="padding: 0 5px;"><b>|</b></span> ${lineHeightPercentage}`;
                        } else {
                            styleInfo.lineHeight = `${lineHeightPx}px}`;
                        }
                    }
        
                    // Extract the main part of textDecoration
                    if (styleInfo.textDecoration) {
                        styleInfo.textDecoration = styleInfo.textDecoration.split(' ')[0]; // Get the first part (e.g., 'none', 'underline')
                    }
        
                    // Handle individual border properties
                    const borderProps = ['borderTop', 'borderRight', 'borderBottom', 'borderLeft'];
                    const borders = borderProps.map(borderProp => borderInfo[borderProp]);
                    const borderValues = borders.map(border => {
                        const [borderWidth, borderStyle, ...borderColorParts] = border.split(' ');
                        const borderColor = borderColorParts.join(' ');
                        return { borderWidth, borderStyle, borderColor: rgbToHex(borderColor) };
                    });
                    const hasBorder = borderValues.some(border => border.borderWidth !== '0px');
        
                    if (hasBorder) {
                        const allBordersSame = borderValues.every(border => 
                            border.borderWidth === borderValues[0].borderWidth &&
                            border.borderStyle === borderValues[0].borderStyle &&
                            border.borderColor === borderValues[0].borderColor
                        );
                        if (allBordersSame) {
                            const { borderWidth, borderStyle, borderColor } = borderValues[0];
                            styleInfo.border = `${borderWidth} ${borderStyle} ${borderColor}`;
                        } else {
                            borderProps.forEach((borderProp, index) => {
                                const { borderWidth, borderStyle, borderColor } = borderValues[index];
                                if (borderWidth !== '0px') {
                                    styleInfo[borderProp] = `${borderWidth} ${borderStyle} ${borderColor}`;
                                }
                            });
                        }
                    }
        
                    // Filter out default border values and individual borders if consolidated
                    borderProps.forEach(borderProp => {
                        if (styleInfo[borderProp] && styleInfo[borderProp].startsWith('0px')) {
                            delete styleInfo[borderProp];
                        }
                    });
                    if (styleInfo.border) {
                        borderProps.forEach(borderProp => {
                            delete styleInfo[borderProp];
                        });
                    }
        
                    // Filter out outline if it has a value of 0px
                    if (styleInfo.outline && styleInfo.outline.includes('0px')) {
                        delete styleInfo.outline;
                    }
        
                    // Construct HTML for the styles and append to the result div
                    const infoHtml = Object.entries(styleInfo).map(([key, value]) => {
                        // Only include properties that have a value and skip default values
                        if (value && !(key in defaultValues && value === defaultValues[key])) {
                            return `<li><b>${key.replace(/([A-Z])/g, ' $1').toUpperCase()}:</b> ${value}</li>`;
                        }
                        return ''; // Return an empty string if the value is not available or is the default value
                    }).filter(Boolean).join(''); // Filter out empty strings
        
                    $(targetElement).closest('.sg-style-info').find('.sg-target-info').append(infoHtml); // Append to the respective result div
                }
            };
        
            // Iterate over each style-info div
            $('.global-style-guide .sg-style-info').each(function () {
                const styleSetClass = $(this).attr('class').match(/sg-style-set\d+/)[0]; // Get the style set class
                const targetElement = $(this).find('.sg-target'); // Find the target element
        
                // Apply hover, focus, or active state class if needed
                if ($(this).text().includes(':HOVER')) {
                    targetElement.addClass('hover');
                } else if ($(this).text().includes(':FOCUS')) {
                    targetElement.addClass('focus');
                } else if ($(this).text().includes(':ACTIVE')) {
                    targetElement.addClass('active');
                }
        
                // Delay to ensure styles are applied
                setTimeout(() => {
                    handleStyleExtraction(targetElement, styleSetClass);
                }, 500); // Delay to ensure styles are applied
            });
        }

        $('.promo-container').addClass('d-none');
        if (($('.info-hub-promotions').css('display') !== 'none') && $('.info-hub-promotions').hasClass('show') && !$('.promo-container').hasClass('show')) {
            $('.my-offers-button').trigger('click');
        }

        if (($('.info-hub-promotions').css('display') !== 'none') && $('.my-offers-container').length > 0) {
            $('body').addClass('info-hub-section');

            $('.my-offers-button').addClass('d-flex d-lg-inline-flex');
        } else {
            $('body').removeClass('info-hub-section');
        }

        var shopbycolorproductCarousel = $('.promo-main');

        if (!shopbycolorproductCarousel.hasClass('slick-initialized')) {
            applySlick(shopbycolorproductCarousel);
        }

        if ($('#storerocket-widget').length > 0) {
            var shopbycolorproductCarousel = $('.promo-main');
            if (!shopbycolorproductCarousel.hasClass('slick-initialized')) {
                shopbycolorproductCarousel.slick({
                    mobileFirst: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                    infinite: false,
                    arrows: true,
                    autoplay: false,
                    responsive: [{
                        breakpoint: 1240,
                        settings: {
                            slidesToShow: 5,
                            slidesToScroll: 1,
                            dots: false
                        }
                    }, {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            dots: false
                        }
                    }, {
                        breakpoint: 544,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 300,
                        settings: {
                            slidesToShow: 8 / 6,
                            slidesToScroll: 1,
                        }
                    }
                    ]
                });
            }
        }

        // Below code is required to add the .rc-container class for the Reusable component to adjust the spacing properly
        // Find all .rc-main elements
        var rcMainElements = $('.rc-main');

        // Iterate over each .rc-main element
        rcMainElements.each(function () {
            var rcMain = $(this);

            // Traverse up the DOM tree to find if any parent has .container class
            var containerParent = rcMain.parents('.container');

            // If a parent with .container class is found and does not already have .rc-container class
            if (containerParent.length > 0 && !containerParent.hasClass('rc-container')) {
                containerParent.addClass('rc-container');
            }
        });
    });

    if ($('.promo-main').find('.promo-item').length > 0) {
        $('.my-offers-button span.count').text($('.promo-item').length);
    }

    if ($('.my-offers-container').length > 0) {

        $(window).on("resize orientationchange", function () {
            if (/Mobi|Android/i.test(navigator.userAgent) && $('.my-offers-container').hasClass('active')) {
                setTimeout(function () {
                    $('.promo-main').slick('reinit');
                }, 500);
            }

            if ($(window).width() <= 960 && $('.checkout-path').length > 0 && $('.modal-background, html,  body').hasClass('info-hub-active')) {
                $('.modal-background.info-hub-active').trigger('click');
            }
        });

        $('#info-hub-promotions').on('click', function (e) {
            if (!$('.promo-container').hasClass('show')) {
                if (e.target != $('#content-area')[0]) {
                    $('.my-offers-button, .my-offers-container').removeClass('active');
                }
            }
        })

        $(document).on('click', '.modal-background.info-hub-active', function () { //to remove reset the promotion box and background
            $('.promo-container').removeClass('show');
            $('.promo-container').addClass('d-none');
            $('.my-offers-button, .my-offers-container').removeClass('active');
            $('.modal-background, html, body').removeClass('info-hub-active');
        })

        $('.my-offers-button').on('click', function (e) {
            e.preventDefault();

            if ($('.modal-background').length > 0 && $('.modal-background, html,  body').hasClass('info-hub-active') && $('.promo-container').hasClass('show')) {
                $('.modal-background,html, body').removeClass('info-hub-active'); //remove grey blurr
                $('.promo-container').removeClass('show'); //hides promotions
                $('.promo-container').addClass('d-none');
                $(this).removeClass('active');
                $('.my-offers-container').removeClass('active');
            } else {
                $('.modal-background, html, body').addClass('info-hub-active'); // add black  blur
                $('.promo-container').addClass('show');//shows promotions
                $('.promo-container').removeClass('d-none');
                $(this).addClass('active');
                $('.my-offers-container').addClass('active');
            }

            var shopbycolorproductCarousel = $('.promo-main');

            setTimeout(function () {
                $(shopbycolorproductCarousel).slick('reinit');
            });
        });

        $(document).on('click', 'button.details', function (e) {
            e.preventDefault();
            var $curObj = $(this);
            var $descriptionContent = $($curObj).closest('.promo-text-section').find('.promo-details-description');
            if ($($descriptionContent).hasClass('active') || !$($descriptionContent).find('.promo-details-main').text().length > 0) {
                $($descriptionContent).removeClass('active');
            } else {
                $($descriptionContent).addClass('active');
            }
        });

        $(document).on('click', '.close-btn', function () {
            var $curObj = $(this);
            var $descriptionContent = $($curObj).closest('.promo-text-section').find('.promo-details-description');
            $($descriptionContent).removeClass('active');
        });

        $(document).on("keypress", ".close-btn:focus", function (e) {
            if (e.key == "Enter" || e.keyCode == 13) {
                $(this).closest('.promo-text-section').find('.promo-details-description').removeClass('active');
            }
        });

        $(window).keydown(function (e) {
            var keyCode = window.event ? e.keyCode : e.which;
            if ($('.promo-details-description.active').length > 0) {
                if (keyCode == 38) {
                    $('.promo-details-description.active').animate({ scrollTop: 0 }, 0);
                    return false;
                } else if (keyCode == 40) {
                    $('.promo-details-description.active').animate({ scrollTop: $('.promo-details-description.active').height() }, 0);
                    return false;
                }
            }
        });

        $('.my-offers-button, .my-offers-container').removeClass('active');
    }

    $('.header-brands-logo-bar .top-menu__link').click(function (event) {
        if (!$(this).hasClass('active')) {
            event.preventDefault();
            var isctrlKeyPress = false;
            if (event.ctrlKey) {
                isctrlKeyPress = true;
            }
            var linkURL = $(this).attr('href');
            let baseURL = linkURL.split('?');
            let searchParams = new URLSearchParams(linkURL.slice(linkURL.indexOf('?') + 1));
            var newURL = searchParams.get('url');
            if (baseURL && baseURL.length > 0) {
                baseURL = baseURL[0];
            }
            var gaCookieVal = getCookie('_ga');
            var gcl_au_CookieVal = getCookie('_gcl_au');
            var ga_Z5TQNFGHHV_CookieVal = getCookie('_ga_Z5TQNFGHHV');

            if (newURL) {
                if (gaCookieVal) {
                    newURL += (newURL.indexOf('?') > -1 ? '&' + '_ga=' + gaCookieVal : '?' + '_ga=' + gaCookieVal);
                }

                if (gcl_au_CookieVal) {
                    newURL += (newURL.indexOf('?') > -1 ? '&' + '_gcl_au=' + gcl_au_CookieVal : '?' + '_gcl_au=' + gcl_au_CookieVal);
                }

                if (ga_Z5TQNFGHHV_CookieVal) {
                    newURL += (newURL.indexOf('?') > -1 ? '&' + '_ga_Z5TQNFGHHV=' + ga_Z5TQNFGHHV_CookieVal : '?' + '_ga_Z5TQNFGHHV=' + ga_Z5TQNFGHHV_CookieVal);
                }
            }
            let newAppendedURL = baseURL + '?url=' + encodeURIComponent(newURL);
            if (isctrlKeyPress) {
                window.open(newAppendedURL, '_blank');
            } else {
                window.location.href = newAppendedURL;
            }
        }
    });
};